import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { SwitchSubPortfolioGroupForm } from './SwitchSubPortfolioGroupForm'

export function SwitchSubPortfolioGroupCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook(
    'mutators.unitlink.useSwitchSubPortfolioGroupActions',
  )({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.SwitchSubPortfolioGroupCommandData"
      title={translate('switchSubPortfolioGroupModalButton.title')}
      commandDataForm={SwitchSubPortfolioGroupForm}
      {...props}
      submit={submit}
    />
  )
}
